import { StringUtils } from "../../../../shared/utils/string.utils";

export const MILLISECONDS_IN_YEAR = 31536000000;

/**
 * Returns date as string in a format "YYYY-MM-DD, HH:MM:SS"
 */
export function formatDatetime(date: number): string {
  if (date == null || date <= 0) {
    return "";
  }

  const time = new Date(date);
  const year = time.getFullYear();
  let month = time.getMonth() + 1 + "";
  if (month.length === 1) {
    month = "0" + month;
  }

  let day = time.getDate() + "";
  if (day.length === 1) {
    day = "0" + day;
  }

  const hour = ("0" + time.getHours()).slice(-2) + "";
  const minutes = ("0" + time.getMinutes()).slice(-2) + "";
  const seconds = ("0" + time.getSeconds()).slice(-2) + "";

  return `${year}-${month}-${day}, ${hour}:${minutes}:${seconds}`;
}

/**
 * Formats a timestamp (in ms) as "YYYY-MM-DD"
 */
export function formatDate(date: number, format?: string): string {
  if (date == null || date <= 0) {
    return "";
  }

  const time = new Date(date);
  const year = time.getFullYear();
  let month = time.getMonth() + 1 + "";
  if (month.length === 1) {
    month = "0" + month;
  }

  let day = time.getDate() + "";
  if (day.length === 1) {
    day = "0" + day;
  }

  switch (format) {
    case "YYYYMMDD":
      return `${year}${month}${day}`;
    default: // YYYY-MM-DD
      return `${year}-${month}-${day}`;
  }
}

/**
 * Adds a specified number of days to a timestamp and returns the new timestamp.
 */
export function addDays(timestamp: number, days: number) {
  const result = new Date(timestamp);
  result.setDate(result.getDate() + days);
  return result.getTime();
}

/**
 * Converts years to a future timestamp (in milliseconds),
 * calculated from the current date.
 */
export function convertYearsLeftToDate(years: any) {
  if (StringUtils.isNullOrEmpty(years)) {
    return 0;
  }

  const yearsLeft = parseFloat(years);

  if (years <= 0) {
    return 0;
  }

  const currentDate = Date.now();
  const calculatedMiliseconds = currentDate + yearsLeft * MILLISECONDS_IN_YEAR;
  return calculatedMiliseconds;
}

/**
 * Calculates the approximate number of years left from the current date
 * until the specified future timestamp.
 */
export function convertDateToYearsLeft(timestamp: number): string {
  if (timestamp == null || timestamp <= 0) {
    return "";
  }

  const currentDate = Date.now();
  const millisecondsLeft = timestamp - currentDate;
  if (millisecondsLeft <= 0) {
    return "0";
  }

  const yearsLeft = millisecondsLeft / MILLISECONDS_IN_YEAR;

  // If yearsLeft is small than 0.1 it means that there are still a couple of days left from a year to be displayed
  // If yearsLeft equals 0.0005 means that we are already in the current date
  if (yearsLeft < 0.1 && yearsLeft > 0.0005) {
    return yearsLeft.toFixed(4);
  } else {
    return yearsLeft.toFixed(1);
  }
}

/**
 * Calculates the approximate number of years passed from the specified timestamp
 * until the current date.
 */
export function convertDateToYearsPassed(timestamp: number): string {
  if (timestamp == null || timestamp <= 0) {
    return "";
  }

  const currentDate = Date.now();
  const millisecondsPassed = currentDate - timestamp;
  if (millisecondsPassed < 0) {
    return "0";
  }

  const yearsPassed = millisecondsPassed / MILLISECONDS_IN_YEAR;

  if (yearsPassed < 0.1 && yearsPassed > 0.0005) {
    return yearsPassed.toFixed(4);
  } else {
    return yearsPassed.toFixed(1);
  }
}
